"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { CreateWaveOutcomeConfigWinner, CreateWaveOutcomeConfigWinnersConfig, CreateWaveOutcomeConfigWinnersCreditValueType, CreateWaveOutcomeType } from "@/types/waves.types";
import CreateWaveOutcomesWinnersAddWinner from "./CreateWaveOutcomesWinnersAddWinner";
import CreateWaveOutcomesWinnersRows from "./CreateWaveOutcomesWinnersRows";
export default function CreateWaveOutcomesWinners(t0) {
  const $ = _c(49);
  const {
    winnersConfig,
    totalValueError,
    percentageError,
    outcomeType,
    setWinnersConfig
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      [CreateWaveOutcomeType.MANUAL]: "Manual",
      [CreateWaveOutcomeType.REP]: "Rep",
      [CreateWaveOutcomeType.NIC]: "NIC"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const OUTCOME_TYPE_LABELS = t1;
  let t2;
  if ($[1] !== setWinnersConfig || $[2] !== winnersConfig) {
    t2 = e => {
      const value = parseInt(e.target.value);
      if (!isNaN(value)) {
        setWinnersConfig({
          ...winnersConfig,
          totalAmount: value
        });
      } else {
        setWinnersConfig({
          ...winnersConfig,
          totalAmount: 0
        });
      }
    };
    $[1] = setWinnersConfig;
    $[2] = winnersConfig;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const onTotalAmountChange = t2;
  let t3;
  if ($[4] !== winnersConfig.creditValueType || $[5] !== winnersConfig.totalAmount || $[6] !== winnersConfig.winners) {
    t3 = () => {
      if (winnersConfig.creditValueType === CreateWaveOutcomeConfigWinnersCreditValueType.PERCENTAGE) {
        return winnersConfig.totalAmount;
      }
      return winnersConfig.winners.reduce(_temp, 0);
    };
    $[4] = winnersConfig.creditValueType;
    $[5] = winnersConfig.totalAmount;
    $[6] = winnersConfig.winners;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const getTotal = t3;
  let t4;
  if ($[8] !== getTotal || $[9] !== setWinnersConfig || $[10] !== winnersConfig) {
    t4 = () => {
      setWinnersConfig({
        ...winnersConfig,
        totalAmount: getTotal()
      });
    };
    $[8] = getTotal;
    $[9] = setWinnersConfig;
    $[10] = winnersConfig;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== winnersConfig.creditValueType || $[13] !== winnersConfig.winners) {
    t5 = [winnersConfig.winners, winnersConfig.creditValueType];
    $[12] = winnersConfig.creditValueType;
    $[13] = winnersConfig.winners;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  useEffect(t4, t5);
  let t6;
  if ($[15] !== setWinnersConfig || $[16] !== winnersConfig) {
    t6 = winners => {
      setWinnersConfig({
        ...winnersConfig,
        winners
      });
    };
    $[15] = setWinnersConfig;
    $[16] = winnersConfig;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  const setWinners = t6;
  let t7;
  if ($[18] !== setWinnersConfig || $[19] !== winnersConfig) {
    t7 = () => {
      setWinnersConfig({
        ...winnersConfig,
        winners: [...winnersConfig.winners, {
          value: 0
        }]
      });
    };
    $[18] = setWinnersConfig;
    $[19] = winnersConfig;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  const addWinner = t7;
  const isPercentageCredit = winnersConfig.creditValueType === CreateWaveOutcomeConfigWinnersCreditValueType.PERCENTAGE;
  const isWinnersRowsError = isPercentageCredit ? percentageError : totalValueError;
  let t8;
  if ($[21] !== totalValueError) {
    t8 = totalValueError && <div className="tw-flex tw-items-center tw-gap-x-2"><svg className="tw-size-5 tw-flex-shrink-0 tw-text-error" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M12 8V12M12 16H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg><div className="tw-text-error tw-text-xs tw-font-medium">Total amount must be higher than 0</div></div>;
    $[21] = totalValueError;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== percentageError) {
    t9 = percentageError && <div className="tw-flex tw-items-center tw-gap-x-2"><svg className="tw-size-5 tw-flex-shrink-0 tw-text-error" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M12 8V12M12 16H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg><div className="tw-relative tw-z-10 tw-text-error tw-text-xs tw-font-medium">Total percentage must be 100%</div></div>;
    $[23] = percentageError;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== isPercentageCredit || $[26] !== onTotalAmountChange || $[27] !== outcomeType || $[28] !== totalValueError || $[29] !== winnersConfig.totalAmount) {
    t10 = isPercentageCredit && <div><div className="tw-relative"><input type="text" value={winnersConfig.totalAmount} onChange={onTotalAmountChange} autoComplete="off" className={`${totalValueError ? "tw-ring-error focus:tw-border-error focus:tw-ring-error tw-caret-error tw-text-error" : "tw-ring-iron-650 focus:tw-border-blue-500 focus:tw-ring-primary-400 tw-caret-primary-400 tw-text-white"}  tw-form-input tw-block tw-px-4 tw-pb-3 tw-pt-4 tw-w-full tw-text-base tw-rounded-lg tw-border-0 tw-appearance-none  tw-border-iron-600  tw-peer
tw-bg-iron-900 focus:tw-bg-iron-900 tw-font-medium tw-shadow-sm tw-ring-1 tw-ring-inset  placeholder:tw-text-iron-500 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset  tw-transition tw-duration-300 tw-ease-out`} placeholder=" " /><label className={`${totalValueError ? "peer-focus:tw-text-error tw-text-error" : "peer-focus:tw-text-primary-400 tw-text-iron-500"} tw-absolute tw-cursor-text tw-text-base tw-font-normal tw-duration-300 tw-transform -tw-translate-y-4 tw-scale-75 tw-top-2 tw-origin-[0] tw-bg-iron-900 peer-focus:tw-bg-iron-900 tw-px-2 peer-focus:tw-px-2 peer-placeholder-shown:tw-scale-100 
           peer-placeholder-shown:-tw-translate-y-1/2 peer-placeholder-shown:tw-top-1/2 peer-focus:tw-top-2 peer-focus:tw-scale-75 peer-focus:-tw-translate-y-4 rtl:peer-focus:tw-translate-x-1/4 rtl:peer-focus:tw-left-auto tw-start-1`}>Total Amount</label><div className="tw-pointer-events-none tw-absolute tw-inset-y-0 tw-right-0 tw-flex tw-items-center tw-pr-3"><span className="tw-text-iron-500 tw-text-sm tw-font-normal">{OUTCOME_TYPE_LABELS[outcomeType]}</span></div></div></div>;
    $[25] = isPercentageCredit;
    $[26] = onTotalAmountChange;
    $[27] = outcomeType;
    $[28] = totalValueError;
    $[29] = winnersConfig.totalAmount;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  let t11;
  if ($[31] !== isWinnersRowsError || $[32] !== outcomeType || $[33] !== setWinners || $[34] !== winnersConfig.creditValueType || $[35] !== winnersConfig.winners) {
    t11 = <CreateWaveOutcomesWinnersRows creditValueType={winnersConfig.creditValueType} winners={winnersConfig.winners} isError={isWinnersRowsError} outcomeType={outcomeType} setWinners={setWinners} />;
    $[31] = isWinnersRowsError;
    $[32] = outcomeType;
    $[33] = setWinners;
    $[34] = winnersConfig.creditValueType;
    $[35] = winnersConfig.winners;
    $[36] = t11;
  } else {
    t11 = $[36];
  }
  let t12;
  if ($[37] !== addWinner) {
    t12 = <CreateWaveOutcomesWinnersAddWinner addWinner={addWinner} />;
    $[37] = addWinner;
    $[38] = t12;
  } else {
    t12 = $[38];
  }
  let t13;
  if ($[39] !== t11 || $[40] !== t12) {
    t13 = <div className="tw-flex tw-flex-col tw-gap-y-2">{t11}{t12}</div>;
    $[39] = t11;
    $[40] = t12;
    $[41] = t13;
  } else {
    t13 = $[41];
  }
  let t14;
  if ($[42] !== t10 || $[43] !== t13) {
    t14 = <div className="tw-flex tw-items-start tw-gap-x-3">{t10}{t13}</div>;
    $[42] = t10;
    $[43] = t13;
    $[44] = t14;
  } else {
    t14 = $[44];
  }
  let t15;
  if ($[45] !== t14 || $[46] !== t8 || $[47] !== t9) {
    t15 = <div className="tw-flex tw-flex-col tw-gap-3">{t8}{t9}{t14}</div>;
    $[45] = t14;
    $[46] = t8;
    $[47] = t9;
    $[48] = t15;
  } else {
    t15 = $[48];
  }
  return t15;
}
function _temp(acc, winner) {
  return acc + winner.value;
}